import { useRef, useEffect } from "react";
import React from "react";
import styles from './Episode.module.css'
import AudioPlayer from '../../../Components/Post/AudioPlayer';

export default function Episode(props){

    const episodeRef = useRef()

    
    const handleClick = () => {
        props.setExpandedId(props.episode.guid);
    }

    useEffect(() => {
        if(props.isExpanded){
            episodeRef.current.classList.add(styles.episodeContainerExpand);
        } else {
            episodeRef.current.classList.remove(styles.episodeContainerExpand);
        }
      }, [props.isExpanded]);

    return(
        
        <button ref={episodeRef} onClick={handleClick} className={styles.episodeContainer} >
                <h2 className={styles.episodeTitleMobil} >{props.episode.title}</h2>
                <img src={props.episode.image} className={styles.image} alt={"Episode image"}></img>
                <div className={styles.info}>
                    <div className={styles.context}>
                        <h2 className={styles.episodeTitleWeb} >{props.episode.title}</h2>
                        <h3 className={styles.scripture}>{props.episode.scripture}</h3>
                        <h4 className={styles.preacher}>{props.episode.preacher}</h4>
                        <h4 className={styles.date}>{props.episode.isoDate}</h4>  
                    </div>
                    
                </div>
                {props.isExpanded && <div className={styles.description} dangerouslySetInnerHTML={{ __html: props.episode.discription }} />}
                {props.isExpanded && <div className={styles.audioPlayer}><AudioPlayer episode={props.episode}></AudioPlayer></div>}
                
            
        </button>
    );

}